// Updated by each version bump script. Keep in sync with android\app\build.gradle
export const APP_VERSION = '2.15';
export const APP_BUILD = 112;
export const APP_BUILD_DATE = 'Oct 21, 2026';
